import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col h-full overflow-y-hidden" }

import { Tabs, Tab } from 'vue3-tabs-component';
import { useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter();

function routeTo(selectedTab: { tab: { name: string } }) {
  try {
    router.push({ name: selectedTab.tab.name });
  } catch (e) {
    console.error(e);
  }
}

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Tabs), {
      options: { useUrlFragment: false },
      "nav-class": "flex flex-wrap px-2 mb-2",
      "nav-item-class": "w-32 uppercase hover:text-primary text-md",
      "nav-item-active-class": "border-b-2 border-primary text-primary",
      "nav-item-link-class": "block py-3 mr-8",
      "panels-wrapper-class": "h-full",
      onChanged: routeTo
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Tab), { name: "Seasons" }),
        _createVNode(_unref(Tab), { name: "Presets" }),
        _createVNode(_unref(Tab), { name: "Brands" }),
        _createVNode(_unref(Tab), { name: "Wrestlers" }),
        _createVNode(_unref(Tab), { name: "Teams" }),
        _createVNode(_unref(Tab), { name: "Users" }),
        _createVNode(_unref(Tab), { name: "Socials" }),
        _createVNode(_unref(Tab), { name: "System" })
      ]),
      _: 1
    }),
    _createVNode(_component_router_view)
  ]))
}
}

})